import { Box } from '@mui/material';
import {
  ResponseDataHandle,
  ListPlaceholder,
  ErrorList,
  EmptyData,
} from '@/components/common';
import { ITablePaginationProps } from '@/components/common/Table/TablePagination';
import { Category } from '@/@types/category';
import { CategoriesTable } from '../CategoriesTable';
import { CategoriesTableColumns } from '../CategoriesTable/CategoriesTableColumns';

type TCategoriesData = {
  categories: Category[];
  totalCount: number;
};

interface ICategoriesListProps {
  isLoading: boolean;
  isError: boolean;
  data: TCategoriesData | undefined;
  sort?: 'desc' | 'asc';
  sortBy?: keyof Category;
  // eslint-disable-next-line no-unused-vars
  onSort?: (header: string) => void;
  actions: object;
  pagination?: ITablePaginationProps;
}

export function CategoriesList({
  isLoading,
  isError,
  data,
  sort,
  sortBy,
  onSort,
  actions,
  pagination,
}: ICategoriesListProps) {
  return (
    <ResponseDataHandle
      isLoading={isLoading}
      loadingComponent={
        <ListPlaceholder headers={['Nome', 'Criado em', 'Ações']} />
      }
      isError={isError}
      errorComponent={
        <Box py={10}>
          <ErrorList text="Falha ao obter os dados das categorias." />
        </Box>
      }
      totalItems={data?.totalCount}
      emptyComponent={
        <Box py={10}>
          <EmptyData />
        </Box>
      }
    >
      <CategoriesTable
        columns={CategoriesTableColumns}
        data={data?.categories || []}
        sort={sort}
        sortBy={sortBy}
        onSort={onSort}
        actions={actions}
        pagination={pagination}
      />
    </ResponseDataHandle>
  );
}
